import React from 'react'

// Shared by the customer File Settings tab and the order header.
// See documentation/FILE_NAMING.md for how a convention is resolved.

export const FILE_NAMING_PRESETS = {
  system: '{task.supplier.userid}-{task.title}-{task.filenumber}.{file.ext}',
  original: '{file.title}.{file.ext}',
}

export const FILE_NAMING_OPTIONS = [
  { value: 'system', label: 'System' },
  { value: 'original', label: 'Original' },
  { value: 'custom', label: 'Custom' },
]

export const FILE_NAMING_MARKERS = [
  ['{order.name}', 'Name of the order'],
  ['{order.uid}', 'Numeric id of the order'],
  ['{task.title}', 'Title of the task'],
  ['{task.uid}', 'Numeric id of the task'],
  ['{task.supplier.userid}', 'Public name (userid) of the supplier'],
  ['{task.filenumber}', 'Sequential number - starting from 1 and unique for each file in a download or delivery'],
  ['{file.ext}', 'The original file extension'],
  ['{file.title}', 'The original filename (without the extension) use this to force the original name'],
  ['{file.uid}', 'Numeric id of the file'],
]

// Presets are stored both with and without a leading "/" (legacy UI)
export const getFileNamingPreset = (convention) => {
  const preset = Object.keys(FILE_NAMING_PRESETS).find((key) => (
    convention === FILE_NAMING_PRESETS[key] || convention === `/${FILE_NAMING_PRESETS[key]}`
  ))

  return FILE_NAMING_OPTIONS.find(({ value }) => value === (preset || 'custom'))
}

export const FileNamingMarkers = () => (
  <table>
    <tbody>
      { FILE_NAMING_MARKERS.map(([marker, description]) => (
        <tr key={marker}>
          <td className="pr-4">{ marker }</td>
          <td>{ description }</td>
        </tr>
      )) }
    </tbody>
  </table>
)
